/**
 * Reminder for accounts whose email address is not confirmed yet. Until it is, invitations sent
 * to that address are not linked to the account and no notification emails are sent to it.
 */
import React, { useState } from 'react';
import { Alert, Button, CircularProgress } from '@mui/material';
import { axiosService } from 'shared/helpers/axios';

export default function EmailVerificationBanner({ user }) {
  const [state, setState] = useState({ busy: false, message: '' });
  if (!user || user.email_verified !== false) return null;
  const resend = async () => {
    setState({ busy: true, message: '' });
    try {
      const res = await axiosService.post('/auth/verify-email/resend/');
      setState({ busy: false, message: res.data?.detail || 'We sent a new confirmation link.' });
    } catch (e) {
      setState({ busy: false, message: e.response?.status === 429
        ? 'Please wait a little before requesting another link.'
        : 'Could not send the link. Please try again later.' });
    }
  };
  return (
    <Alert
      severity="warning"
      sx={{ mb: 2, alignItems: 'center' }}
      action={(
        <Button color="inherit" size="small" onClick={resend} disabled={state.busy}
                startIcon={state.busy ? <CircularProgress size={14} color="inherit" /> : null}>
          Resend link
        </Button>
      )}
    >
      {state.message || (
        <>Please confirm your email address: we sent a link to <strong>{user.email}</strong>. Until then,
          invitations sent to this address are not linked to your account and we send you no notification emails.</>
      )}
    </Alert>
  );
}
